// extracted by mini-css-extract-plugin
export var phone = "_58-0";